<template>
  <div
    class="mom-state"
    :class="`mom-state--${kind}`"
    :role="kind === 'error' ? 'alert' : 'status'"
    :dir="$i18n.locale === 'en' ? 'ltr' : 'rtl'"
  >
    <custom-loading
      v-if="kind === 'loading'"
      :size="30"
    />
    <p class="mom-state__title">
      {{ titleText }}
    </p>
    <p
      v-if="hintText"
      class="mom-state__hint"
    >
      {{ hintText }}
    </p>
    <div class="d-flex flex-wrap justify-content-center">
      <b-button
        v-if="kind === 'error'"
        variant="primary"
        @click="$emit('retry')"
      >
        {{ $t('foundation.retry') }}
      </b-button>
      <b-button
        v-if="kind === 'filtered'"
        variant="outline-primary"
        @click="$emit('clear')"
      >
        {{ $t('foundation.clearSearch') }}
      </b-button>
      <slot />
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import CustomLoading from '@/components/CustomLoading/index.vue'

const COPY = {
  loading: ['foundation.loading', ''],
  empty: ['foundation.emptyTitle', 'foundation.emptyHint'],
  filtered: ['foundation.noResultsTitle', 'foundation.noResultsHint'],
  error: ['foundation.loadErrorTitle', 'foundation.loadErrorHint'],
  forbidden: ['foundation.forbiddenTitle', 'foundation.forbiddenHint'],
}

export default {
  name: 'AppDataState',
  components: { BButton, CustomLoading },
  props: {
    kind: {
      type: String,
      default: 'empty',
      validator: value => Object.keys(COPY).includes(value),
    },
    title: { type: String, default: '' },
    hint: { type: String, default: '' },
  },
  computed: {
    titleText() { return this.title || this.$t(COPY[this.kind][0]) },
    hintText() { return this.hint || (COPY[this.kind][1] ? this.$t(COPY[this.kind][1]) : '') },
  },
}
</script>
